/* import __COLOCATED_TEMPLATE__ from './duplicate-gtin-and-sku-save-confirmation-modal-body.hbs'; */
import Component from '@ember/component';
export default class extends Component {}